<template>
  <div>
    <div class="images-block">
      <img v-for="(item, index) in imagesList" :src="item" :key="index" width="300" height="300">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imagesList: []
    };
  },
  created() {
  },
  mounted() {
    this.$http.sysResGetRes({type: 1}).then(res => {
      if(res.data !== null) {
        this.imagesList.push(res.data.content1)
      }
    })
  },
  methods:{
  }
};
</script>
<style>
  .images-block img {
    margin-top: 10px;
    margin-left: 50px;
  }

</style>
